import collectionReducer from '../collectionReducer';

export default collectionReducer({
    collectionActionName: 'APM_SERIES_CAMERAS',
    itemActionName: 'APM_SERIES_CAMERA',
});
